
import ElaryWarningInfoList from './src/elaryWarning/ElaryWarningInfoList.vue' //公告管理列表 
import ElaryWarningHistoryList from './src/elaryWarning/ElaryWarningHistoryList.vue' //公告管理详情 

import ElaryWarningInfo from './src/elaryWarning/ElaryWarningInfo.vue' //告警管理列表 

let views = {
  ElaryWarningInfoList,
  ElaryWarningHistoryList,
  ElaryWarningInfo
};

export default views;